import * as React from "react";
import DateUtils from "../../utils/DateUtils";
import moment = require("moment");
import IconLarge from "../../hiberUiKit/src/atoms/Icon/IconLarge";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";


interface ComponentProps {
	/**
	 * Date presented.
	 */
	date: moment.Moment;
	/**
	 * "Next" button click callback.
	 */
	onNextDayClick: () => void;
	/**
	 * "Previous" button click callback.
	 */
	onPreviousDayClick: () => void;
}

type Props = ComponentProps

/**
 * Day picker component.
 */
export default class DayViewDayPicker extends React.PureComponent<Props, {}> {
	render() {
		return (
			<div className={"c-day-picker"}>
				<div className={"c-day-picker_date"}>
					<div className={"c-day-picker_current-date"}>
						{this.props.date.format(DateUtils.DAILY_PLAN_DATE_FORMAT_WO_YEAR)} <span style={{fontWeight: "normal"}}>
						{this.props.date.format(DateUtils.ONLY_YEAR_FORMAT)}</span>
						</div>
					<div className={"c-day-picker_day-name"}>{this.props.date.format(DateUtils.NAME_OF_DAY_ONLY_FORMAT)}</div>
				</div>
				<div className={"c-day-picker_actions"}>
					<IconLarge icon={Icon.ArrowLeft} variant={"burgundy"} onClick={this.props.onPreviousDayClick}/>
					<IconLarge icon={Icon.ArrowRight} variant={"burgundy"} onClick={this.props.onNextDayClick}/>
				</div>
			</div>
		);
	}
}
